/**
 * ODAKI Cart — drawer + cart page (AJAX)
 */
(function () {
  "use strict";

  var config = {};
  var drawer = null;
  var overlay = null;
  var drawerBody = null;
  var drawerFooterHost = null;
  var shippingBarHost = null;
  var pageRoot = null;
  var pageBody = null;
  var pageSidebar = null;
  var lastFocus = null;

  function readConfig() {
    var node = document.getElementById("odk-cart-config");
    var base = {};
    if (node) {
      try {
        base = JSON.parse(node.textContent);
      } catch (e) {
        base = {};
      }
    }
    var pageNode = document.getElementById("odk-cart-page-config");
    if (pageNode) {
      try {
        var pageCfg = JSON.parse(pageNode.textContent);
        Object.keys(pageCfg).forEach(function (key) {
          if (key === "strings" && pageCfg.strings) {
            base.strings = base.strings || {};
            Object.assign(base.strings, pageCfg.strings);
          } else {
            base[key] = pageCfg[key];
          }
        });
      } catch (e) { /* ignore */ }
    }
    return base;
  }

  function escHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var n = Number(number);
    var p = precision == null ? 2 : precision;
    var t = thousands == null ? "," : thousands;
    var d = decimal == null ? "." : decimal;

    if (!isFinite(n) || !isFinite(p)) return "0";

    var fixed = n.toFixed(p).split(".");
    var dollars = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
    var centsPart = fixed[1] ? d + fixed[1] : "";
    return dollars + centsPart;
  }

  function formatMoney(cents) {
    var format = config.moneyFormat || "${{amount}}";
    var value = Number(cents);
    if (!isFinite(value)) value = 0;
    var amount = value / 100;

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case "amount":
          return formatWithDelimiters(amount, 2, ",", ".");
        case "amount_no_decimals":
          return formatWithDelimiters(amount, 0, ",", ".");
        case "amount_with_comma_separator":
          return formatWithDelimiters(amount, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return formatWithDelimiters(amount, 0, ".", ",");
        case "amount_with_apostrophe_separator":
          return formatWithDelimiters(amount, 2, "'", ".");
        case "amount_with_space_separator":
          return formatWithDelimiters(amount, 2, " ", ",");
        case "amount_no_decimals_with_space_separator":
          return formatWithDelimiters(amount, 0, " ", ",");
        default:
          return formatWithDelimiters(amount, 2, ",", ".");
      }
    });
  }

  function itemCountLabel(count) {
    var tpl = count === 1 ? config.strings.itemCountOne : config.strings.itemCountOther;
    return (tpl || "").replace("{{ count }}", count);
  }

  function setLoading(on) {
    if (drawer) drawer.classList.toggle("is-loading", on);
    if (pageRoot) pageRoot.classList.toggle("is-loading", on);
  }

  function showError(message) {
    document.querySelectorAll("[data-cart-error]").forEach(function (el) {
      el.textContent = message || config.strings.errorGeneric;
      el.classList.add("is-visible");
    });
  }

  function clearError() {
    document.querySelectorAll("[data-cart-error]").forEach(function (el) {
      el.classList.remove("is-visible");
    });
  }

  function updateBadges(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll("[data-count]").forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
    document.querySelectorAll("[data-cart-count-label]").forEach(function (el) {
      el.textContent = itemCountLabel(count);
    });
  }

  function shippingHtml(cart) {
    if (!config.showFreeShippingBar || !config.freeShippingThreshold) return "";
    var threshold = Number(config.freeShippingThreshold);
    var total = cart.total_price;
    var remaining = Math.max(0, threshold - total);
    var progress = Math.min(100, Math.round((total / threshold) * 100));
    var unlocked = remaining <= 0;
    var text = unlocked
      ? config.strings.freeShippingUnlocked
      : config.strings.freeShippingRemaining.replace("{{ amount }}", formatMoney(remaining));

    return [
      '<div class="odk-cart-shipping' + (unlocked ? " is-unlocked" : "") + '" data-cart-shipping>',
      '<p class="odk-cart-shipping__text">' + text + "</p>",
      '<div class="odk-cart-shipping__track"><span class="odk-cart-shipping__fill" style="width:' + progress + '%"></span></div>',
      "</div>"
    ].join("");
  }

  function variantLabel(item) {
    if (item.variant_options && item.variant_options.length) {
      return item.variant_options.join(" / ");
    }
    if (item.variant_title && item.variant_title !== "Default Title") {
      return item.variant_title;
    }
    if (item.title && item.product_title && item.title.indexOf(item.product_title) === 0) {
      var suffix = item.title.slice(item.product_title.length).replace(/^[\s\-–—/]+/, "").trim();
      if (suffix) return suffix;
    }
    return "";
  }

  function metaHtml(item) {
    var parts = [];
    if (config.showVendor && item.vendor) {
      parts.push('<p class="odk-cart-item__vendor">' + escHtml(item.vendor) + "</p>");
    }
    var variant = variantLabel(item);
    if (variant) {
      parts.push('<p class="odk-cart-item__variant">' + escHtml(variant) + "</p>");
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      parts.push('<p class="odk-cart-item__plan">' + escHtml(item.selling_plan_allocation.selling_plan.name) + "</p>");
    }
    if (!parts.length) return "";
    return '<div class="odk-cart-item__meta">' + parts.join("") + "</div>";
  }

  function lineItemHtml(item, index) {
    var line = index + 1;
    var title = item.product_title || item.title || "";
    var img = item.image
      ? '<img src="' + escHtml(item.image) + '" alt="' + escHtml(title) + '" loading="lazy" width="96">'
      : "";
    var meta = metaHtml(item);
    var compare =
      item.original_line_price !== item.final_line_price
        ? '<s class="odk-cart-item__price-compare">' + formatMoney(item.original_line_price) + "</s>"
        : "";
    var minusDisabled = item.quantity <= 1 ? " disabled" : "";

    return [
      '<li class="odk-cart-item" data-item-key="' + escHtml(item.key) + '" data-line="' + line + '">',
      '<a href="' + escHtml(item.url) + '" class="odk-cart-item__media" tabindex="-1" aria-hidden="true">',
      img,
      "</a>",
      '<div class="odk-cart-item__body">',
      '<a href="' + escHtml(item.url) + '" class="odk-cart-item__title">' + escHtml(title) + "</a>",
      meta,
      '<div class="odk-cart-item__footer">',
      '<div class="odk-cart-item__qty" role="group" aria-label="' + escHtml(config.strings.quantity) + '">',
      '<button type="button" class="odk-cart-item__qty-btn" data-qty-change="-1" data-line="' + line + '" data-current="' + item.quantity + '" aria-label="' + escHtml(config.strings.decrease) + '"' + minusDisabled + "><span aria-hidden=\"true\">&minus;</span></button>",
      '<span class="odk-cart-item__qty-val" aria-live="polite">' + item.quantity + "</span>",
      '<button type="button" class="odk-cart-item__qty-btn" data-qty-change="1" data-line="' + line + '" data-current="' + item.quantity + '" aria-label="' + escHtml(config.strings.increase) + '"><span aria-hidden="true">+</span></button>',
      "</div>",
      '<div class="odk-cart-item__prices">',
      '<span class="odk-cart-item__price">' + formatMoney(item.final_line_price) + "</span>",
      compare,
      "</div>",
      "</div>",
      "</div>",
      '<button type="button" class="odk-cart-item__remove" data-remove-item data-line="' + line + '" aria-label="' + escHtml(config.strings.remove.replace("{{ title }}", title)) + '">',
      '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>',
      "</button>",
      "</li>"
    ].join("");
  }

  function itemsHtml(cart) {
    var html = '<ul class="odk-cart-items" id="cart-items-list">';
    cart.items.forEach(function (item, i) {
      html += lineItemHtml(item, i);
    });
    html += "</ul>";
    return html;
  }

  function emptyHtml() {
    return [
      '<div class="odk-cart-empty" id="cart-empty-state">',
      '<div class="odk-cart-empty__icon">',
      '<svg viewBox="0 0 56 56" aria-hidden="true">',
      '<path d="M18 22v-6a10 10 0 0 1 20 0v6"/>',
      '<rect x="8" y="22" width="40" height="28" rx="2"/>',
      '<line x1="22" y1="34" x2="34" y2="34"/>',
      "</svg>",
      "</div>",
      '<p class="odk-cart-empty__title">' + escHtml(config.strings.empty) + "</p>",
      '<a href="' + escHtml(config.continueUrl) + '" class="odk-cart-empty__btn">' + escHtml(config.strings.continue) + "</a>",
      "</div>"
    ].join("");
  }

  function summaryHtml(cart, includeViewCart) {
    var viewCart = includeViewCart
      ? '<a href="' + escHtml(config.routes.cart) + '" class="odk-cart-summary__link">' + escHtml(config.strings.viewCart) + "</a>"
      : "";
    return [
      '<div class="odk-cart-summary">',
      '<div class="odk-cart-summary__row">',
      '<span class="odk-cart-summary__label">' + escHtml(config.strings.subtotal) + "</span>",
      '<span class="odk-cart-summary__price" data-cart-subtotal>' + formatMoney(cart.total_price) + "</span>",
      "</div>",
      '<p class="odk-cart-summary__note">' + escHtml(config.strings.shippingNote) + "</p>",
      '<a href="' + escHtml(config.routes.checkout) + '" class="odk-cart-summary__checkout">' + escHtml(config.strings.checkout) + "</a>",
      viewCart,
      "</div>"
    ].join("");
  }

  function recommendationsHtml(cart) {
    if (!config.showRecommendations || !config.recommendations || !config.recommendations.length) return "";
    var cartIds = cart.items.map(function (i) { return i.product_id; });
    var items = config.recommendations.filter(function (p) {
      return cartIds.indexOf(p.id) === -1;
    }).slice(0, 4);
    if (!items.length) return "";

    var cards = items.map(function (p) {
      var img = p.image ? '<img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : "";
      return [
        '<a href="' + escHtml(p.url) + '" class="odk-cart-recs__card">',
        '<div class="odk-cart-recs__media">' + img + "</div>",
        '<p class="odk-cart-recs__name">' + escHtml(p.title) + "</p>",
        '<p class="odk-cart-recs__price">' + escHtml(p.priceFormatted || formatMoney(p.price)) + "</p>",
        "</a>"
      ].join("");
    }).join("");

    return [
      '<div class="odk-cart-recs" data-cart-recs>',
      '<p class="odk-cart-recs__title">' + escHtml(config.strings.recommendationsTitle) + "</p>",
      '<div class="odk-cart-recs__grid">',
      cards,
      "</div>",
      "</div>"
    ].join("");
  }

  function fetchCrossSell(productId) {
    if (!productId || !config.routes || !config.routes.recommendations) return Promise.resolve("");
    var url = config.routes.recommendations
      + "?section_id=cart-cross-sell&intent=complementary&limit=4&product_id=" + encodeURIComponent(productId);
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  // Tras agregar un producto, intenta mostrar sugerencias específicas
  // (venta cruzada nativa de Shopify) en lugar de las recomendaciones
  // genéricas por colección. Si no hay ninguna, se deja el respaldo tal cual.
  function applyCrossSell(productId) {
    if (!productId) return;
    return fetchCrossSell(productId).then(function (html) {
      // Shopify always wraps the response in a (possibly empty)
      // <div class="shopify-section">; only proceed if it actually contains
      // our recommendations markup.
      if (!html || html.indexOf("data-cart-recs") === -1) return;
      var replaced = false;
      document.querySelectorAll("[data-cart-recs]").forEach(function (el) {
        el.outerHTML = html;
        replaced = true;
      });
      if (replaced) return;
      // No existing recommendations block to swap (e.g. no fallback collection
      // configured), so append the cross-sell block after the line items.
      if (drawerBody) drawerBody.insertAdjacentHTML("beforeend", html);
      if (pageBody) pageBody.insertAdjacentHTML("beforeend", html);
    });
  }

  function renderCart(cart) {
    clearError();
    updateBadges(cart.item_count);

    var shipping = shippingHtml(cart);

    if (drawer) {
      if (shippingBarHost) shippingBarHost.innerHTML = cart.item_count > 0 ? shipping : "";

      if (cart.item_count === 0) {
        drawerBody.innerHTML = emptyHtml();
        if (drawerFooterHost) drawerFooterHost.innerHTML = "";
        var recs = drawer.querySelector("[data-cart-recs-wrap]");
        if (recs) recs.innerHTML = "";
      } else {
        drawerBody.innerHTML = itemsHtml(cart) + recommendationsHtml(cart);
        if (drawerFooterHost) {
          drawerFooterHost.innerHTML = cart.item_count > 0
            ? '<div class="cart-drawer__footer">' + summaryHtml(cart, true) + "</div>"
            : "";
        }
      }
    }

    if (pageRoot && pageBody) {
      if (shippingBarHost && pageRoot.contains(shippingBarHost)) {
        shippingBarHost.innerHTML = cart.item_count > 0 ? shipping : "";
      } else {
        var pageShip = pageRoot.querySelector("[data-cart-shipping-wrap]");
        if (pageShip) pageShip.innerHTML = cart.item_count > 0 ? shipping : "";
      }

      if (cart.item_count === 0) {
        pageBody.innerHTML = emptyHtml();
        if (pageSidebar) pageSidebar.hidden = true;
        var pageRecs = pageRoot.querySelector("[data-cart-recs-wrap]");
        if (pageRecs) pageRecs.innerHTML = "";
      } else {
        pageBody.innerHTML = itemsHtml(cart);
        if (pageSidebar) {
          pageSidebar.hidden = false;
          var summary = pageSidebar.querySelector("[data-cart-summary]");
          if (summary) summary.innerHTML = summaryHtml(cart, false);
        }
      }
    }
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } }).then(function (r) {
      return r.json();
    });
  }

  function fetchAndRender(openDrawer) {
    setLoading(true);
    return fetchCart()
      .then(function (cart) {
        renderCart(cart);
        if (openDrawer) open();
      })
      .catch(function () {
        showError();
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function changeLine(line, quantity) {
    setLoading(true);
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("change failed");
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function () {
        showError();
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var closeBtn = drawer.querySelector(".cart-drawer__close");
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== "FORM") return false;
    var action = (form.getAttribute("action") || "").toLowerCase();
    return action.indexOf("/cart/add") !== -1;
  }

  function saveNote(note) {
    setLoading(true);
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: note })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("note failed");
        return r.json();
      })
      .catch(function () {
        showError();
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function bindEvents() {
    if (overlay) overlay.addEventListener("click", close);

    var closeBtn = drawer && drawer.querySelector(".cart-drawer__close");
    if (closeBtn) closeBtn.addEventListener("click", close);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) close();
    });

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-cart-icon], .cap-cart-btn");
      if (trigger) {
        if (trigger.tagName === "A") e.preventDefault();
        fetchAndRender(true);
        return;
      }

      var root = e.target.closest(".cart-drawer, .cart-page");
      if (!root) return;

      var qtyBtn = e.target.closest("[data-qty-change]");
      if (qtyBtn) {
        var delta = parseInt(qtyBtn.dataset.qtyChange, 10);
        var line = parseInt(qtyBtn.dataset.line, 10);
        var current = parseInt(qtyBtn.dataset.current, 10);
        changeLine(line, Math.max(0, current + delta));
        return;
      }

      var removeBtn = e.target.closest("[data-remove-item]");
      if (removeBtn) {
        var item = removeBtn.closest(".odk-cart-item");
        if (item) item.classList.add("is-removing");
        changeLine(parseInt(removeBtn.dataset.line, 10), 0);
        return;
      }

      var noteBtn = e.target.closest("[data-cart-note-save]");
      if (noteBtn) {
        var input = pageRoot && pageRoot.querySelector("[data-cart-note]");
        if (input) saveNote(input.value);
      }
    });

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!isCartAddForm(form)) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || "Error"); });
          return r.json();
        })
        .then(function (addedItem) {
          return fetchAndRender(true).then(function () {
            return applyCrossSell(addedItem && addedItem.product_id);
          });
        })
        .catch(function (err) {
          showError(err.message);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    document.addEventListener("cart:updated", function (e) {
      var shouldOpen = !e.detail || e.detail.open !== false;
      fetchAndRender(shouldOpen);
    });
  }

  function init() {
    config = readConfig();
    drawer = document.getElementById("cart-drawer");
    overlay = document.getElementById("cart-overlay");
    pageRoot = document.getElementById("cart-page");

    if (drawer) {
      drawerBody = document.getElementById("cart-drawer-body");
      drawerFooterHost = document.getElementById("cart-drawer-footer");
      shippingBarHost = document.getElementById("cart-drawer-shipping");
    }

    if (pageRoot) {
      pageBody = document.getElementById("cart-page-body");
      pageSidebar = document.getElementById("cart-page-sidebar");
    }

    bindEvents();

    window.CartDrawer = {
      open: open,
      close: close,
      refresh: function () { return fetchAndRender(false); }
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
